var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("EmployeeMultiselect", {
    attrs: {
      value: _vm.chosenManagers,
      options: _vm.managersOptions,
      multiple: _vm.multiple,
      "select-label": _vm.selectLabel,
      "deselect-label": _vm.deselectLabel,
      invalid: _vm.invalid,
      placeholder: _vm.placeholderText,
      loading: _vm.isLoading,
      disabled: _vm.disabled,
      noOptionsText: "No managers",
      withoutLoading: "",
    },
    on: {
      search: (v) => (_vm.managerSearchString = v),
      input: _vm.handleInput,
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }